<template>
  <div class="submit1">
    <el-form :model="formData">
      <!-- <div class="head">
        <span class="red">1.填写联系人及问题描述</span>
        <i class="el-icon-arrow-right el-icon"></i>
        <span>2.上传故障图片或视频</span>
      </div> -->
      <el-form-item>
        <div class="red label">* 联系人</div>
        <el-input
          v-model="formData.connect"
          class="inp"
          placeholder="请输入联系人姓名（第二次下单会自动写入）"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div class="label red">* 联系电话</div>
        <el-input
          v-model="formData.phone"
          class="inp"
          placeholder="请输入联系人电话（第二次下单会自动写入）"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div class="label">联系邮箱</div>
        <el-input
          v-model="formData.contact_number"
          class="inp"
          placeholder="请输入联系人邮箱"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div class="label red">* 故障描述</div>
        <el-input
          v-model="formData.sales_feedback"
          type="textarea"
          rows="8"
          resize="none"
          show-word-limit
          maxlength="500"
          placeholder="请输入故障描述"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <div class="submitFoot">
          <el-button class="subBtn" @click="subBtn"
            >下一步：上传故障照片或视频</el-button
          >
        </div>
        -->
      </el-form-item>
    </el-form>
    <el-alert
      class="tip"
      @close="onClose"
      v-show="isErr"
      title="表单信息缺失"
      type="error"
    >
    </el-alert>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    baseFormData: {
      type: Object,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      isErr: false,
      formData: {},
    };
  },
  created() {
    this.init();
  },
  mounted() {
  },
  watch: {
  },

  methods: {
    init() {
      this.formData = this.baseFormData;
    },
    onClose() {
      this.isErr = false;
    },
    subBtn() {
      if (
        !this.formData.connect ||
        !this.formData.phone ||
        // !this.formData.contact_number ||
        !this.formData.sales_feedback
      ) {
        this.$toast.fail('*必填项不能为空');
      } else {
        this.$emit("next", this.formData);
      }
    },
  },
};
</script>



<style scoped lang="scss">
.submit1 {
  .head {
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;
    background: rgba(255, 255, 255, 1);
    padding: 0 10px;
    .el-icon {
      font-size: 24px;
      color: rgba(153, 153, 153, 1);
      font-weight: 900;
    }
  }

  .el-form {
    .el-form-item {
      margin: 0;
      .inp {
        height: 40px;
      }
      .label {
        width: 100%;
        height:  40px;
        line-height:  40px;
      }
    }

    .submitFoot {
      width: 100%;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      position: fixed;
      bottom: 0;
      .subBtn {
        width: 348px;
        height: 48px;
        background: rgba(255, 87, 51, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
        border-radius: 15px;
      }
    }
  }
  .tip {
    position: fixed;
    top: 0px;
  }
}
</style>